/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from "../../models/core/IceEntity";
import { notebookpage } from "../../models/customforms/notebookpage";
import { NotebookItemObject } from "./notebookitemobject";

export class NotebookPageObject extends IceEntity {
  page: notebookpage = null;
  layout: string = "";

  backColor: string = "";
  items: NotebookItemObject[] =[];
  pageIndex: number = -1;

  constructor(pg: notebookpage) {
    super();
    this.page = pg;
  }

  getItems(): NotebookItemObject[] {
    return this.items;
  }
  resetItems(): void {
    for (let i = 0; i < this.items.length; i++ ){
      let pObj =  this.items[i];
      if (pObj != null) {
        this.items[i] = null;
      }
    }
    this.items = [];
  }

  onPositionChange(pParentWnd): void {
    // Not needed in browser
  }

  addItem(ritemObj: NotebookItemObject): NotebookItemObject {
    let pitemObj: NotebookItemObject = null;
    try {
      pitemObj = new NotebookItemObject();
      if (ritemObj != null)
        pitemObj.copy(ritemObj);

      this.items.push(pitemObj);
    }
    catch (error)
    {
      pitemObj = null;
      console.log(error);
    }
    return pitemObj;
  }

  getItem(nindex: number): NotebookItemObject {
    if (nindex >= 0 && nindex < this.items.length) {
      let pitemObj = this.items[nindex];
      return pitemObj;
    }
    return null;
  }

  getItemByFieldName(lpszTableName: string, lpszColumnName: string): NotebookItemObject {
    for (let i = 0; i < this.items.length; i++ ) {
      let pObj =  this.items[i];
      if (pObj != null) {
        if (pObj.m_strTableName.toUpperCase() == lpszTableName.toUpperCase()
          && pObj.m_strFieldName.toUpperCase() == lpszColumnName.toUpperCase()) {
          return pObj;
        }
        else {
          for (let iSubItem = 0; iSubItem < pObj.m_sub_items.length; iSubItem++) {
            let pItemTest = pObj.m_sub_items[iSubItem];
            if (pItemTest != null) {
              if (pItemTest.m_strTableName.toUpperCase() == lpszTableName.toUpperCase()
                && pItemTest.m_strFieldName.toUpperCase() == lpszColumnName.toUpperCase()) {
                return pItemTest;
              }
            }
          }
        }
      }
    }
    return null;
  }

  removeItem(pItem: NotebookItemObject): void {
    for (let i = 0; i < this.items.length; i++ ) {
      let pObj =  this.items[i];
      if (pObj == pItem)
      {
        this.items[i] = null;
        delete this.items[i];
        return;
      }
    }
  }

  getItemCount(): number{
    return this.items.length;
  }

  setBackColor(dwColor: string): void {
    this.backColor = dwColor;
  }
  getBackColor(): string {
    return this.backColor;
  }

  getPageIndex(): number {
    return this.pageIndex;
  }

  setPageIndex(pIdx: number): void {
    this.pageIndex = pIdx;
  }

  copy(rNBPageObj: NotebookPageObject): void {
    if (rNBPageObj != null) {
      this.page = rNBPageObj.page;
      this.pageIndex = rNBPageObj.pageIndex;
      this.layout = rNBPageObj.layout;
    }
  }
}

